// Environment
// export const ENV = 'dev';
export const ENV = 'prod';

// Code Assist
export const UPDATE_SEARCH = 'UPDATE_SEARCH';
export const FETCH_LIBRARY = 'FETCH_LIBRARY';
export const CHANGE_PAGE = 'CHANGE_PAGE';
export const CHANGE_FOCUS = 'CHANGE_FOCUS';

// Code Block Editor
export const FETCH_CODE_LIBRARY = 'FETCH_CODE_LIBRARY';
export const CLICK_COLLECTION_ITEM = 'CLICK_COLLECTION_ITEM';
export const CHANGE_INPUT = 'CHANGE_INPUT';
export const SAVE_NEW_CODE_OBJECT = 'SAVE_NEW_CODE_OBJECT';
export const UPDATE_EXISTING_CODE_OBJECT = 'UPDATE_EXISTING_CODE_OBJECT'
export const DELETE_CODE_OBJECT = 'DELETE_CODE_OBJECT';


// WEBPACK FOOTER //
// ./src/actions/types.js